export default function getNameById(options, id) {
  let res = '-'
  if (options && options.length > 0) {
    const filter = options.filter((item) => item.id == id)
    if (filter.length > 0) {
      res = filter[0].name
    }
  }
  return res
}
